// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___3lhLM","wrapper":"wrapper___3r1aB","footer-1":"footer-1___vixWt footer___3lhLM","footer-2":"footer-2___1h2m1 footer___3lhLM","footerVertical-1":"footerVertical-1___1LdMQ footer___3lhLM","footerVertical-2":"footerVertical-2___1Eqkk footer___3lhLM","other":"other___2C4yf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Footer/index.scss
// module id = 98
// module chunks = 0